import React, { FunctionComponent, SVGProps, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import Dots from '@/assets/img/dots-3.svg';
import './FunnelFilterMenu.scss';
import ActionIcon from '@/assets/rewise/action-btn.svg';
import Delete from '@/assets/steam/delete.svg';
import { default as ReactSelect, components } from 'react-select';
import FilterIcon from '@/assets/steam/filter.svg';
import { ReactComponent as Calendericon } from '@/assets/steam/calender-frame.svg';
import DatePicker, { DayRange } from 'react-modern-calendar-datepicker';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import { City, State, UserRole } from '@/features/users/types/indes';
import { useGetCityList, useGetCityListonStates, useGetStateList } from '@/features/users/api/getRefrences';
import { User } from '@/types';
import moment from 'moment';
import Checkmark from '@/assets/steam/green-check.png';
import SortAsc from '@/assets/steam/sort-asc.svg';
import SortDesc from '@/assets/steam/sort-desc.svg';
import Sort from '@/assets/steam/sort.svg';

export type ActionMenu = {
  label: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  onClickHandler: (params: any) => any;
  itemClassName: string;
};

type ActionMenuProps = {
  options?: ActionMenu[];
  isDropdown?: boolean;
  isVerticalIcon?: boolean;
  roles?: any;
  usersList?: any;
  onRoleSelect: (filter: any) => void;
  showRoleFilter?: boolean;


};

export const FunnelFilterMenu = ({ options, isDropdown = true, isVerticalIcon, roles, usersList, onRoleSelect, showRoleFilter = true }: ActionMenuProps) => {
  const [selectedRole, setSelectedRole] = useState<any[]>()
  const [cities, setCities] = useState<any[]>()
  const [selectedUsers, setSelectedUsers] = useState<User[]>();
  const [selectedFunnelType, setSelectedFunnelType] = useState<any[]>();
  const [selectedDateType, setSelectedDateType] = useState<any[]>();
  const useGetCityMutation = useGetCityList();
  const useGetCityListonStatess = useGetCityListonStates();
  const [delaSize, setDealSize] = useState<any>('');
  const [selectedDate, setSelectedDate] = useState<any>();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [setFunnelStages, setStages] = useState<any[]>();
  const [filteredUsersList, setFilteredUsersList] = useState<any[]>();
  const [selectedSort, setSelectedSort] = useState<any>();
  const [isSoretedAsc, setIsSoretedAsc] = useState('');
  const [selectedState, setSelectedState] = useState<State[]>();
  const [selectedCity, setSelectedCity] = useState<City[]>();
  const [stateSelected, setStateSelected] = useState<any>();
  const [states, setStates] = useState<State[]>([]);
  const useGetStateMutation = useGetStateList();

  

  useEffect(() => {
    getStateList();
    if (usersList && usersList.length > 0 && selectedRole && selectedRole.length > 0) {
      const selectedRoleIds = selectedRole.map((role) => Number(role.id));
  
      const filteredUsers = usersList.filter((user:any) =>
        selectedRoleIds.includes(Number(user.userRoleId))
      );
  
      setFilteredUsersList(filteredUsers);
    } else {
      setFilteredUsersList(usersList);
    }
  }, [usersList, selectedRole]);

  const getCityList = async (statess: any) => {
    const stateIds = statess?.map((item:any)=>item?.id)
    const res = await useGetCityListonStatess.mutateAsync({ stateIds });
    if (res) {
      setCities(res.list);
    }
  };


  const getStateList = async () => {
    const res = await useGetStateMutation.mutateAsync({
      search: ''
    });
    if (res) {
      setStates(res.list);
    }
  };


  const getSelectedFunnelStages = () => {
    const selectedStages = [];

    if (selectedFunnelType && selectedFunnelType.some(funnel => funnel.id === 1)) {
      selectedStages.push(...productFunnelStage);
    }

    if (selectedFunnelType && selectedFunnelType.some(funnel => funnel.id === 2)) {
      selectedStages.push(...bookFunnelStage);
    }

    return selectedStages;
  };



  const clearFilter = () => {
    setIsSoretedAsc('')
    setSelectedUsers([]);
    setSelectedSort([]);
    setSelectedRole([]);
    setSelectedFunnelType([]);
    setStages([]);
    setDealSize('')
    setSelectedDate('')
    setSelectedDateType([]);
    onRoleSelect(null)
    setIsDropdownOpen(false);
  }

  const formatDateRange = () => {
    return selectedDate
      ? moment({
        year: selectedDate?.year,
        month: selectedDate?.month ? selectedDate?.month - 1 : 0,
        day: selectedDate?.day,
      }).format('DD MMM YYYY')
      : '';
  };

  const funnelTypes = [
    { name: "Platform Funnel", id: 1 },
    { name: "Books Funnel", id: 2 }
  ];

  const bookFunnelStage = [
    { name: "Initial Sampling", id: 7 },
    { name: "Positive Feedback", id: 8 },
    { name: "Full Set Review", id: 9 },
    { name: "Price Discussion/Quotation", id: 10 },
    { name: "Price & Quantity Finalised", id: 11 },
    { name: "Order Confirmed", id: 12 },
    { name: "Advance Received", id: 13 },
    { name: "Deal Lost", id: 14 },
  ];

  const productFunnelStage = [
    { name: "Initial Interest", id: 1 },
    { name: "Demo Scheduled", id: 2 },
    { name: "Demo Completed", id: 3 },
    { name:"Trial Ongoing", id: 4 },
    { name: "Deal Won", id: 5},
    { name: "Deal Lost", id:6 }
  ];

  const dateTypes = [
    { name: "Overdue", id: 1 },
    { name: "Upcoming", id: 2 },
    { name: "Today", id: 3 }
  ];

  const sortTypes = [
    { name: "Deal Size: Low to High", id: 1 },
    { name: "Deal Size: High to Low", id: 2 },
    { name: "Followup Date (Overdue first)", id: 3 },
    { name: "Followup Date (Overdue last)", id: 4 },
  ];


  const applyFilter = (sort?:any) => {
    const rolesIds = selectedRole && selectedRole.length > 0 ? selectedRole.map((item: any) => Number(item.id)) : [];
    const funnelStageIds = setFunnelStages && setFunnelStages.length > 0 ? setFunnelStages.map((item: any) => Number(item.id)) : [];
    const userIds = selectedUsers && selectedUsers.length > 0 ? selectedUsers.map((item: any) => Number(item.id)) : [];
    const funnelTypes = selectedFunnelType && selectedFunnelType.length > 0 ? selectedFunnelType.map((item: any) => Number(item.id)) : [];
    const dateTypes = selectedDateType && selectedDateType.length > 0 ? selectedDateType.map((item: any) => Number(item.id)) : [];
    const sortedOrder = sort ? sort : null;
    setIsDropdownOpen(false)
    onRoleSelect({ 'roleId': rolesIds, 'userId': userIds, "funnelType": funnelTypes, "date": dateTypes,"funnelStageIds" :funnelStageIds, "dealSize": delaSize ,"sortedOrder": sortedOrder})
  }


  const isShowfilerCheck = () =>{
    if(selectedRole && selectedRole.length > 0){
      return true
    }else if(setFunnelStages && setFunnelStages.length > 0){
      return true
    }else if (selectedUsers && selectedUsers.length>0){
      return true
    }else if (selectedFunnelType && selectedFunnelType.length>0){
      return true
    }else if (selectedDateType && selectedDateType.length>0){
      return true
    }else if(selectedCity && selectedCity.length > 0){
      return true
    }else if (stateSelected){
      return true
    }else{
      return false
    }
  }

  return (
    <>
    <div className='sorting-icon' onClick={()=>{
      if(isSoretedAsc === 'asc'){
        setIsSoretedAsc('desc')
        applyFilter('desc')

      }else{
        setIsSoretedAsc('asc')
        applyFilter('asc')
      }
     
    }}>
              <img src={isSoretedAsc ==='desc' ? SortDesc : isSoretedAsc ==='asc'? SortAsc : Sort} className="filter-icon fixed-width" />
              </div>
      <Dropdown className={`funnel-filter-menu dot-3-btn ${isVerticalIcon ? 'is-vertical-icon' : ''}`}  show={isDropdownOpen}
        onToggle={(isOpen) => setIsDropdownOpen(isOpen)}>
        <Dropdown.Toggle id="dropdown-basic" className="dots-3-icon btn-1">
          <img src={isVerticalIcon ? FilterIcon : FilterIcon} className="filter-icon fixed-width" />
          {isShowfilerCheck() &&  <img src={Checkmark} className='green-checkmark'/>}
        </Dropdown.Toggle>
        <Dropdown.Menu className="drop-down-backdrop">
          <div className="action-no-dropdown-funnel">
            <div className="user-first-last-div petsked-form mb-3">
              <ReactSelect
                className="multiselect-react funnel-filter-width"
                options={funnelTypes ? funnelTypes : []}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  setSelectedFunnelType(selected);
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                components={{
                  Option: Option2,
                  ValueContainer: ValueContainer2,
                }}
                placeholder={'Select funnel type'}
                value={selectedFunnelType}

              />

            </div>
            <div className="user-first-last-div petsked-form mb-3">
              <ReactSelect
                className="multiselect-react funnel-filter-width"
                options={getSelectedFunnelStages() ? getSelectedFunnelStages() : []}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  setStages(selected);
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                components={{
                  Option: Option4,
                  ValueContainer: ValueContainer4,
                }}
                placeholder={'Select funnel stages'}
                value={setFunnelStages}

              />

            </div>
            <div className="user-first-last-div petsked-form mb-3">

            <ReactSelect
                  className="multiselect-react funnel-filter-width"
                  options={roles ? roles : []}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  classNamePrefix={'petsked-multiselect'}
                  onChange={(selected: any) => {
                    setSelectedRole(selected);
                  }}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  components={{
                    Option: Option1,
                    ValueContainer: ValueContainer1,
                  }}
                  placeholder={'Select role'}
                  value={selectedRole}

                />
           

            </div>
            <div>

              <div className="user-first-last-div petsked-form mb-3">
                <ReactSelect
                  className="multiselect-react funnel-filter-width"
                  options={filteredUsersList ? filteredUsersList : []}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  classNamePrefix={'petsked-multiselect'}
                  onChange={(selected: any) => {
                    setSelectedUsers(selected);
                  }}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  components={{
                    Option: Option,
                    ValueContainer: ValueContainer,
                  }}
                  placeholder={'Select user'}
                  value={selectedUsers}

                />

              </div>
            </div>

            <div className="user-first-last-div petsked-form mb-3">
              <ReactSelect
                className="multiselect-react funnel-filter-width"
                options={dateTypes ? dateTypes : []}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  setSelectedDateType(selected);
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                components={{
                  Option: Option3,
                  ValueContainer: ValueContainer3,
                }}
                placeholder={'Follow-up Date'}
                value={selectedDateType}

              />

            </div>

            {/* <div className="user-first-last-div petsked-form mb-3">
              <ReactSelect
                className="multiselect-react filter-height filter-fixed-width petsked-sort-filter"
                options={sortTypes ? sortTypes : []}
                isMulti={false}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                isSearchable={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  if (selected) {
                    setSelectedSort(selected); 
                  }
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                placeholder={'Sort By'}
                value={selectedSort}

              />
              </div> */}

            {/* <div className='minimum-deal-size-field'>
              <div className='input-data'>
                <input
                  className={`custome-input change-font`}
                  placeholder={'Minimum Deal size'}
                  onChange={(e) => {
                    setDealSize(e.target.value);
                  }}
                  value={delaSize}
                  id="dealSize"
                />
              </div>

            </div> */}

            {/* <div className='minimum-deal-size-field date-selector'>
              <DatePicker
                formatInputText={formatDateRange}
                value={selectedDate}
                onChange={(newDate: any) => {
                  if (newDate) {
                    setSelectedDate(newDate);
                  }
                }}
                inputPlaceholder="Select date"
                inputClassName='steam-rangepicker'
                colorPrimary="#002083"
                colorPrimaryLight="#002083"
              />
            </div> */}


{/* {states && states.length > 0 && <div className="user-first-last-div petsked-form mb-3">

<ReactSelect
                className="multiselect-react filter-height"
                options={states ? states : []}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  setSelectedState(selected); 
                  setCities([]); 
                  setSelectedCity([]); 
                  setStateSelected(selected.name); 
                  getCityList(selected);
                  //applyFilter()
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                components={{
                  Option: Option6,
                  ValueContainer: ValueContainer6,
                }}
                placeholder={'Select state'}
                value={selectedState}

              />
            </div>}
            {cities && cities.length > 0 && <div className="user-first-last-div petsked-form mb-3">
              <ReactSelect
                className="multiselect-react filter-height"
                options={cities ? cities : []}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  setSelectedCity(selected);
                  //applyFilter()
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                components={{
                  Option: Option5,
                  ValueContainer: ValueContainer5,
                }}
                placeholder={'Select city'}
                value={selectedCity}

              />
            </div>} */}
          </div>


          <div className='action-filter-funnel'>
            <button onClick={() => { applyFilter() }} className='steam-button button-dark' >

              {/* <SearchIcon /> */}
              Search
            </button>
            <button onClick={() => { clearFilter() }} className='steam-button invert-button'>
              {/* <img src={Delete} className='filter-clear-icon' /> */}
              Reset
            </button>
          </div>
        </Dropdown.Menu>
      </Dropdown>

    </>
  );
};


const Option5 = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer6 = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select State</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added States`}
      {React.Children.map(props.children, (child) => {
        if (child) {
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};

const Option6 = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer5 = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select Cities</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added Cities`}
      {React.Children.map(props.children, (child) => {
        if (child) {
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};

const Option = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select users</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added Users`}
      {React.Children.map(props.children, (child) => {
        if (child) {
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};





const Option1 = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer1 = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select roles</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added Roles`}
      {React.Children.map(props.children, (child) => {
        if (child) {
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};


const Option2 = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer2 = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select funnel type</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added Types`}
      {React.Children.map(props.children, (child) => {
        if (child) {
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};



const Option3 = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer3 = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Follow-up Date</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added Dates`}
      {React.Children.map(props.children, (child) => {
        if (child) {
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};



const Option4 = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer4 = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select funnel stages</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added Types`}
      {React.Children.map(props.children, (child) => {
        if (child) {
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};


FunnelFilterMenu.displayName = 'FunnelFilterMenu';
